import * as React from 'react'

import * as T from 'components/ui/typography'
import useTranslation from 'next-translate/useTranslation'

const PlanNameBox = React.memo(({ planName }: { planName: string }) => {
    const { t } = useTranslation('common')
    return (
        <div className="flex justify-center bg-accent p-1 mt-2 rounded-full">
            <T.Large className="text-secondary text-sm capitalize">{`${t(
                'plan',
            )}: ${planName?.toLowerCase()}`}</T.Large>
        </div>
    )
})
export default PlanNameBox
